/**
 * Credits data — pure, no Phaser dependency.
 *
 * Each section has a heading and one or more lines. Consumed by CreditsScene.
 */

export interface CreditsSection {
  heading: string;
  lines: readonly string[];
}

export const CREDITS: readonly CreditsSection[] = [
  {
    heading: 'MANOR',
    lines: ['NOIR-PUNK · LONDON · BEAT-EM-UP'],
  },
  {
    heading: 'HEROES',
    lines: [
      'RAY "TANK" MILLER',
      'ERROL "DREAD" CLARKE',
      'KRIS KOWALCZYK',
      'PRIYA "FURY" KAUR',
      '"GHOST"',
    ],
  },
  {
    heading: 'DESIGN & CODE',
    lines: ['MANOR RUNNER', 'DAVID SHELLEY'],
  },
  {
    heading: 'BUILT WITH',
    lines: ['PHASER 3', 'TYPESCRIPT', 'VITE'],
  },
  {
    heading: 'THANK YOU',
    lines: ['FOR FIGHTING FOR LONDON', 'THE STREETS ARE OURS.'],
  },
];
